<script>
import moment from 'moment';
import { contractType } from '@/assets/data/optionData.js';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignFileUpload from '@/components/design-system/design-file-upload.vue';
import { FileValidateUtil } from '@/plugins/app-util.js';

export default {
    props: {
        modelValue: Boolean,
        name: String,
        buttonText: String,
        checkInviteName: String,
        checkButtonText: String,
        // showExcelErrorButton : Boolean
    },
    emits: ['update:modelValue', 'afterClose', 'successInvite'],
    components:{
        DesignButton,
        DesignFileUpload,
    },
    data() {
        return {
            showExcelErrorButton: false,
            showNoFileErrorString: false,
            showNoDataInputString: false,
            showIsEmpty: false,
            inValidFileType: false,
            inValidFileTypeMessage: '',
            disableAddButton: true,
            bulkFile: null,

            showCheckInviteBulkPopup: false,
            checkInvateList: {
                firstName: [],
                lastName: [],
                phoneNumber: [],
                inviteEmail: [],
                joinDate: [],
            },
            errorMessageExcelPath: '',
            sendEmployeeData: [],

            getInviteList: [],
            employmentTypeOptionMap: Object.fromEntries(
                contractType.map(({ value, text }) => [value,text])
            ),
        };
    },
    computed : {
        hasErrorOnUpload(){
            return this.showExcelErrorButton || this.showNoDataInputString || this.showNoFileErrorString ;
        }
    },
    mounted() {
        // const self = this;
    },
    methods: {
        resetData() {
            this.bulkFile = null;
            this.disableAddButton = true;
            this.showExcelErrorButton = false;
            this.showNoFileErrorString = false;
            this.showNoDataInputString = false;
            this.showIsEmpty = false;
            this.inValidFileType = false;
            this.inValidFileTypeMessage = '';
        },
        clickAddButton() {
            this.showCheckInviteBulkPopup = true;
            this.$emit('update:modelValue', false);
        },
        clearUploadErrorMessage() {
            // upload 버튼 누른 순간, 에러메시지 초기화
            this.showExcelErrorButton = false;
            this.showNoFileErrorString = false;
            this.showNoDataInputString = false;
            this.showIsEmpty = false;
            this.inValidFileType = false;
            this.inValidFileTypeMessage = '';
        },
        clickUploadButton(event) {
            event?.preventDefault?.();

            // upload 버튼 누른 순간, 에러메시지 초기화
            this.clearUploadErrorMessage();
            if (!this.bulkFile || !this.bulkFile.name) {
                this.showNoFileErrorString = true;
                return;
            }

            const fileName = this.bulkFile.name;
            if (FileValidateUtil.isXlsFile(fileName)) {
                this.inValidFileType = true;
                this.inValidFileTypeMessage = FileValidateUtil.errMsg.xls;
                return;
            }

            if (!FileValidateUtil.isXlsxFile(fileName)) {
                this.inValidFileType = true;
                this.inValidFileTypeMessage = FileValidateUtil.errMsg.xlsxOnly;
                return;
            }

            const formProps = new FormData();
            formProps.append('multipartFile', this.bulkFile);
            const url = this.$api('uri', 'post-invite-bulk-xlsx');

            this.$axios
                .post(url, formProps, {
                    headers: {
                        'Content-Type': 'multipart/form-data;',
                    },
                })
                .then((res) => {
                    const invalidFile = res.data.data.invalidFile;
                    if (invalidFile) {
                        this.errorMessageExcelPath = res.data.data.data;
                        this.disableAddButton = true;
                        this.showExcelErrorButton = true;
                        return;
                    }

                    this.getInviteList = [];
                    this.checkInvateList = {
                        firstName: [],
                        lastName: [],
                        phoneNumber: [],
                        inviteEmail: [],
                        joinDate: [],
                    };
                    //upload 한 excel 에 문제가 없을 경우 확인 팝업에서 list 확인 가능
                    this.getInviteList = res.data.data.data;
                    this.showCheckInviteBulkPopup = true;
                    this.disableAddButton = false;
                })
                .catch((err) => {
                    console.error('err : ', err);
                    const errCode = err.response.data.code;
                    if(errCode == 'HR_INVITE_BULK_XLSX_UPLOAD_400_FAILED'){
                        this.showIsEmpty = true;
                        return;
                    }
                    if(errCode == FileValidateUtil.notSupported){
                        this.inValidFileType = true;
                        this.inValidFileTypeMessage = FileValidateUtil.errMsg.xlsxOnly;
                        return;
                    }
                    if(errCode == FileValidateUtil.strictOOXML){
                        this.inValidFileType = true;
                        this.inValidFileTypeMessage = FileValidateUtil.errMsg.strictXlsx;
                        return;
                    }
                    this.showNoDataInputString = true;
                });
        },
        clickExcelErrorButton() {
            const self = this;

            const url = self.$api('uri', 'get-invite-bulk-error');
            const json_query = JSON.stringify({
                excelFilePath: self.errorMessageExcelPath,
            });

            location.href =
                url + `?${encodeURIComponent('json_query')}=${encodeURIComponent(json_query)}`;
        },
        clickInviteBulkButton() {
            const self = this;

            self.sendEmployeeData = [];

            self.getInviteList.forEach((employee) => {
                let employeeObj = {
                    employeeName: '',
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    inviteEmail: '',
                    employeeId: '',
                    joinDate: '',
                    department: null,
                    head: null,
                    tier: null,
                    workSchedule: null,
                    office: null,
                    paymentType: null,
                    basicSalaryAmount: null,
                    taxCode: null,
                    pic: null,
                    tinNo: null,
                    sssNo: null,
                    pagIbigNo: null,
                    philHealthNo: null,
                    rdoCode: null,
                    bankName: null,
                    accountNumber: null,
                    employmentType: null,
                };

                employeeObj.employeeName = employee.firstName.trim() + ' ' + employee.lastName.trim();
                employeeObj.firstName = employee.firstName;
                employeeObj.lastName = employee.lastName;
                employeeObj.phoneNumber = employee.phoneNumber;
                employeeObj.inviteEmail = employee.inviteEmail;
                employeeObj.employeeId = employee.employeeId;
                employeeObj.joinDate = employee.joinDate;

                employeeObj.department = employee.department;
                employeeObj.head = employee.head;
                employeeObj.tier = employee.tier;
                employeeObj.workSchedule = employee.workSchedule;
                employeeObj.office = employee.office;
                employeeObj.paymentType = employee.paymentType;
                employeeObj.basicSalaryAmount = employee.basicSalaryAmount;
                employeeObj.taxCode = employee.taxCode;
                employeeObj.pic = employee.pic;
                employeeObj.tinNo = employee.tinNo;
                employeeObj.sssNo = employee.sssNo;
                employeeObj.pagIbigNo = employee.pagIbigNo;
                employeeObj.philHealthNo = employee.philHealthNo;
                employeeObj.rdoCode = employee.rdoCode;
                employeeObj.bankName = employee.bankName;
                employeeObj.accountNumber = employee.accountNumber;
                employeeObj.employmentType = employee.employmentType ?? null;

                //string 만 trim
                for (let key in employeeObj) {
                    employeeObj[key] =
                        typeof employeeObj[key] === 'string'
                            ? employeeObj[key].trim()
                            : employeeObj[key];
                }

                self.sendEmployeeData.push(employeeObj);
            });

            const url = self.$api('uri', 'post-invite-bulk');

            self.$axios
                .post(url, self.sendEmployeeData)
                .then((res) => {
                    self.$emit("update:modelValue", false);
                    self.checkHidePopup();
                    self.$emit('successInvite', 'It is successfully invited ');
                })
                .catch((err) => {
                    console.error('err ? : ', err);
                    if (
                        err.response.data.code ==
                        'HR_EMPLOYEE_UPDATE_500_FAILED_DUPLICATED_EMPLOYEE_ID'
                    ) {
                        alert(
                            'Entered Employee ID No. is duplicated. Please enter other Employee ID No.'
                        );
                    } else {
                        alert('Failed to invite employees. Please try again later.');
                    }
                });
        },
        clickCancelButton() {
            const self = this;
            self.$emit('update:modelValue', false);
        },
        hidePopup() {
            const self = this;

            self.$emit('update:modelValue', false);
            self.$emit('afterClose');
        },
        checkHidePopup() {
            const self = this;
            self.showCheckInviteBulkPopup = false;
        },
        buttonEvent() {
            const self = this;

            self.$emit('buttonEvent');
        },
        convertDateTimeToDate(dateTime) {
            return moment(dateTime).format('MM/DD/YYYY');
        },
    },
};
</script>

<template>
    <div v-show="modelValue" class="z-[80] fixed top-0 w-full h-full bg-black/50 flex justify-center items-center">
        <div class="rounded-3 shadow-modal bg-white overflow-hidden">
            <div class="p-4 flex justify-between items-center border-b-1 border-border-basic-2">
                <h2 class="font-heading-sm-semibold">{{ name }} </h2>
                <a href="javascript:void(0)" class="ml-20" @click="hidePopup">
                    <img src="@/assets/img/app-popup-1.svg" alt="app-popup-1" />
                </a>
            </div>
            <div class="max-h-[70vh] w-[640px] overflow-auto">
                <!-- slot -->
                <div class="p-6 flex flex-col gap-6">
                    <div class="flex flex-col gap-3">
                        <p class="font-body-sm-semibold">Step 1.&nbsp;
                            <span class="text-content-basic-2 font-body-sm-medium">
                                Please download the template first.
                            </span>
                        </p>
                        <a v-if="$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')" class="block"
                            :href="require(`@/assets/file/flexbenOnlyBulkInviteTemplate.xlsx`)"
                            download="bulkInviteTemplate.xlsx">
                            <DesignButton btnText="Download the template" btnSize="FULL" btnType="PRIMARY"
                                :btnDisabled="false">
                                <template #front-icon>
                                    <img src="@/assets/img/download.svg" width="16" height="16" alt="" class="invert" />
                                </template>
                            </DesignButton>
                        </a>
                        <a v-else class="block" :href="require(`@/assets/file/bulkInviteTemplate.xlsx`)"
                            download="bulkInviteTemplate.xlsx">
                            <DesignButton btnText="Download the template" btnSize="FULL" btnType="PRIMARY"
                                :btnDisabled="false">
                                <template #front-icon>
                                    <img src="@/assets/img/download.svg" width="16" height="16" alt="" class="invert" />
                                </template>
                            </DesignButton>
                        </a>
                    </div>
                    <div>
                        <p class="font-body-sm-semibold mb-3">Step 2.&nbsp;
                            <span class="text-content-basic-2 font-body-sm-medium">Please upload the excel template file.</span>
                        </p>
                        <DesignFileUpload v-model="bulkFile" size="LG" :fileName="bulkFile ? bulkFile.name : ''"
                            placeholder="Choose a file" accept=".xlsx" @change="clearUploadErrorMessage" 
                            @delete="bulkFile = null"
                        />
                        <div v-if="showExcelErrorButton" class="flex gap-2 items-center mt-2">
                            <p class="c_alert_message flex-1 min-w-0 break-words">Input error detected. Please click here to check your file and try again</p>
                            <DesignButton btnText="Download Excel with error message" btnSize="SM" btnType="RED" class="shrink-0"
                                btn-variant="BORDER" :btnDisabled="false" @clickEvent="clickExcelErrorButton" />
                        </div>
                        <div v-else-if="showNoFileErrorString">
                            <p class="c_alert_message mt-1">Please upload the template excel file.</p>
                        </div>
                        <div v-else-if="showNoDataInputString">
                            <p class="c_alert_message mt-1">Please upload a valid .xlsx file.</p>
                        </div>
                        <div v-else-if="showIsEmpty">
                            <p class="c_alert_message mt-1 break-words">The uploaded file is empty. Please upload a valid template excel file.</p>
                        </div>
                        <div v-else-if="inValidFileType">
                            <p class="c_alert_message mt-1 break-words">{{ inValidFileTypeMessage }}</p>
                        </div>
                    </div>
                </div>
                <!-- slot -->
            </div>

            <div class="p-4 flex justify-end w-full bg-white gap-2 border-t-1 border-border-basic-2" v-if="buttonText">
                <designButton @click-event="hidePopup" 
                    btnSize="MD" btnType="SECONDARY" btnVariant="BORDER" class="w-[6rem]"
                    btnText="Cancel" :btnDisabled="false" />
                <designButton @click-event="clickUploadButton" :btnText="buttonText"
                    btnSize="MD" btnType="PRIMARY" btnVariant="FILL" class="min-w-[6rem]"
                    :btnDisabled="false" />
            </div>
        </div>
    </div>
    <div
        v-show="showCheckInviteBulkPopup"
        class="z-[100] fixed top-0 w-full h-full bg-black/50 flex justify-center items-center">
        <div class="w-[95vw] max-h-[95vh] border rounded-lg shadow shadow-gray-100 bg-white">
            <div class="px-7 py-6 flex justify-between items-center">
                <h2 class="text-xl font-bold">{{ checkInviteName }}</h2>
                <a href="javascript:void(0)" class="ml-20" @click="checkHidePopup">
                    <img src="@/assets/img/app-popup-1.svg" alt="app-popup-1" />
                </a>
            </div>
            <div class="w-full h-px bg-gray-300"></div>
            <div class="max-h-[50vh] overflow-auto">
                <table class="w-full divide-y divide-gray-300 mx-auto">
                    <thead class="bg-gray-50">
                        <tr>
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >First Name</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Last Name</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Phone Number</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Invite Email</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Join Date</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Department</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Head</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Tier</th
                            >
                            <th v-if="$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Employment Type</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Employee ID No.</th
                            >
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                >Office</th
                            >
                            <template v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')">
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >Work Schedule</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >Payment Type</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >Basic Salary Amount</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >Tax Code</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >TIN</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >SSS No.</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >PhilHealth No.</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >PAG-IBIG No. / HDMF</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >RDO Code</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >Bank Name</th
                                >
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >Account Number</th
                                >
                            </template>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 bg-white">
                        <tr v-for="(employee, index) in getInviteList" v-bind:key="index">
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.firstName
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.lastName
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.phoneNumber
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.inviteEmail
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                convertDateTimeToDate(employee.joinDate)
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.department
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.head
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.tier
                            }}</td>
                            <td v-if="$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')" 
                                class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employmentTypeOptionMap[employee.employmentType]
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.employeeId
                            }}</td>
                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                employee.office
                            }}</td>
                            <template v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')">
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.workSchedule
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.paymentType
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.basicSalaryAmount
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.taxCode
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.tinNo
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.sssNo
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.philHealthNo
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.pagIbigNo
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.rdoCode
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.bankName
                                }}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                                    employee.accountNumber
                                }}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="checkButtonText" class="w-full h-px bg-gray-200"></div>
            <div class="w-full px-4 py-6 flex justify-end" v-if="checkButtonText">
                <ElementsButton
                    text="Cancel"
                    :width28="true"
                    :height12="true"
                    :background-white="true"
                    @click-event="checkHidePopup" />
                <ElementsButton
                    class="ml-2"
                    :text="checkButtonText"
                    :width28="true"
                    :height12="true"
                    @click-event="clickInviteBulkButton" />
            </div>
        </div>
    </div>
</template>
